import { IconType } from 'react-icons'
import { FiBox as catalogIcon, FiTrendingUp as icon } from 'react-icons/fi'

import i from '~/i18n'

import { campaign as campaignTexts, root as rootTexts } from '../i18n/pt-br'
import AdsDashboard from '../pages/ads'
import AdSizes from '../pages/adSizes'
import AdvertiserBrandsPage from '../pages/advertiserBrands'
import AdvertiserProductsPage from '../pages/advertiserProducts'
import { audiencesRoutes } from '../pages/audiences'
import AudiencesEnriched from '../pages/audiences/audiencesEnriched'
import AudienceCreatePage from '../pages/audiences/create'
import ReviewAudience from '../pages/audiences/reviewAudiences'
import AudienceViewPage from '../pages/audiences/view'
import CampaignCreate from '../pages/campaigns/create'
import RetailMediaCampaigns from '../pages/campaigns/list'
import OffsiteAdvertiserReviewList from '../pages/campaigns/offsiteReviewList'
import OffsiteAdvertiserReviewView from '../pages/campaigns/offsiteReviewView'
import CampaignsInReview from '../pages/campaigns/reviewList'
import SpendReportsPage from '../pages/campaigns/spend-reports'
import RetailMediaCampaign from '../pages/campaigns/view'
import RetailMediaCatalog from '../pages/catalog'
import RetailMediaCheck from '../pages/check'
import RetaipMediaAdTypesPage from '../pages/config/adTypes'
import AdvertisersConfig from '../pages/config/advertisers'
import CreateAdvertiserConfig from '../pages/config/advertisers/create'
import DestinationRetailConfigPage from '../pages/config/destinationRetail'
import RetailMediaTermsOfServicePage from '../pages/config/termsOfService'
// import Dashboard from '../pages/dashboard'
import ExternalCampaignMetricsPage from '../pages/external-campaign-metrics'
import * as industryPages from '../pages/industry'
import Links from '../pages/links'
import NetworkDashboard from '../pages/network'
import * as placementsPages from '../pages/placements'
import RetailMediaReport from '../pages/reports'
import CreativeStudioPage from '../pages/tools/creative-studio'
import RequestTesterPage from '../pages/tools/requests'
import { TvRoutes } from '../pages/tv/routes'
import WalletsList from '../pages/walltets/list'
import WalletRecharge from '../pages/walltets/recharge'
import WalletView from '../pages/walltets/view'

function capitalizeI18n(key: string) {
  return i.t('c:capitalize', { value: i.t(key) })
}

/**
 * 1. Dashboard
 */

// const dashboard: ChildMenuItem[] = [
// {
//   path: '/retail-media',
//   id: 'b1ced6c3-13ba-444a-bbd1-13a83d637ee2',
//   name: rootTexts.dashboard,
//   contentFullWidth: true,
//   component: Dashboard,
//   hideMenu: true,
//   containsHome: true
// },
// {
//   path: '/retail-media/realtime',
//   id: null,
//   name: rootTexts.dashboard,
//   contentFullWidth: true,
//   component: RealtimeDashboardRetailMedia,
//   hideMenu: true,
//   containsHome: true
// }
// ]

/**
 * 2. Listagem de vínculos (publisher - apenas rede / anunciantes)
 */
const links: ChildMenuItem[] = [
  {
    path: '/retail-media/publishers',
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    name: rootTexts.publishers,
    contentFullWidth: true,
    component: Links,
    onlyNewtail: true,
    onlyAdvertiser: true
  },
  {
    path: '/retail-media/advertisers',
    sidebarStartsClosed: true,
    id: '02069c18-fd76-4f56-a7a0-a1ccbdf96947',
    name: rootTexts.advertisers,
    contentFullWidth: true,
    component: Links,
    onlyPublisher: true
  }
]

/**
 * 3. Listagem de campanhas
 */
const campaigns: ChildMenuItem[] = [
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/campaigns',
    childPaths: ['/retail-media/campaign'],
    name: campaignTexts.menu.campaigns,
    contentFullWidth: true,
    component: RetailMediaCampaigns
  },
  /**
   * 3.1. Listagem de campanhas em revisão
   */
  {
    sidebarStartsClosed: true,
    id: null,
    path: '/retail-media/campaigns/review',
    name: rootTexts.campaigns,
    contentFullWidth: true,
    component: CampaignsInReview,
    hideMenu: true,
    onlyPublisher: true
  },
  /**
   * 3.1.1. Fila de revisão de campanhas offsite (anunciante)
   *
   * Fica ao lado da revisão do publisher de propósito: são a mesma tarefa vista
   * por personas diferentes, e a rota do item logo abaixo.
   */
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/campaigns/offsite-review',
    name: rootTexts.campaigns,
    hideMenu: true,
    onlyAdvertiser: true,
    contentFullWidth: true,
    component: OffsiteAdvertiserReviewList
  },
  /**
   * 3.1.2. Revisão de uma campanha offsite pelo anunciante
   */
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/campaigns/offsite-review/:id',
    name: rootTexts.campaigns,
    contentFullWidth: true,
    component: OffsiteAdvertiserReviewView,
    hideMenu: true,
    onlyAdvertiser: true
  },
  /**
   * 3.2. Relatório de consumo de orçamento
   */
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/campaign/view/:id/spend-reports',
    name: campaignTexts.menu.view,
    hideMenu: true,
    contentFullWidth: true,
    component: SpendReportsPage
  },
  /**
   * 3.3. Visualização de campanha
   */
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/campaign/view/:id',
    name: campaignTexts.menu.view,
    hideMenu: true,
    contentFullWidth: true,
    component: RetailMediaCampaign
  },
  /**
   * 3.4. Criação de campanha
   */
  {
    id: null, // rota-sem-id
    path: '/retail-media/campaign/create',
    name: campaignTexts.menu.create,
    hideMenu: true,
    component: CampaignCreate,
    onlyAdvertiser: true
  }
]

/**
 * 4. Anúncios
 */

const ads: ChildMenuItem[] = [
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/ads',
    name: campaignTexts.menu.ads,
    contentFullWidth: true,
    component: AdsDashboard
  }
]

/**
 * 5. Rede
 */

const subPublishers: ChildMenuItem[] = [
  {
    path: '/retail-media/network',
    sidebarStartsClosed: true,
    id: null,
    name: rootTexts.network,
    contentFullWidth: true,
    component: NetworkDashboard,
    onlyNetwork: true,
    onlyPublisher: true
  }
]

/**
 * 6. Carteiras
 */
const wallets: ChildMenuItem[] = [
  {
    id: '2e0ef368-6ac5-4c10-b8e3-88e1721b7382',
    path: '/retail-media/wallets',
    childPaths: ['/retail-media/wallet'],
    name: campaignTexts.menu.wallet,
    component: WalletsList
  },
  {
    id: '2e0ef368-6ac5-4c10-b8e3-88e1721b7382',
    path: '/retail-media/wallet/:id/:section?',
    name: campaignTexts.menu.wallet,
    component: WalletView,
    hideMenu: true
  },
  {
    id: '2e0ef368-6ac5-4c10-b8e3-88e1721b7382',
    path: '/retail-media/wallet/:id/recharge',
    name: campaignTexts.menu.wallet,
    component: WalletRecharge,
    hideMenu: true
  },
  {
    id: null, // rota-sem-id
    path: '/retail-media/wallet/:id/transaction/:transactionId',
    name: campaignTexts.menu.wallet,
    hideMenu: true,
    component: industryPages.WalletPages.RechargeTransaction,
    onlyAdvertiser: true
  }
]

/**
 * 7. Placements
 */
const placements: ChildMenuItem[] = [
  {
    id: '334211a3-4385-11ef-99b5-0aa6baaecec9',
    path: '/retail-media/placements',
    onlyPublisher: true,
    name: `${i.t('rm:placements.list.pageTitle')}`,
    pageTitle: i.t('rm:placements.list.pageTitle'),
    component: placementsPages.list
  },
  {
    id: '334211a3-4385-11ef-99b5-0aa6baaecec9',
    path: '/retail-media/placements/:id/edit',
    onlyPublisher: true,
    pageTitle: i.t('rm:placements.edit.pageTitle'),
    name: i.t('rm:placements.edit.pageTitle'),
    component: placementsPages.list,
    hideMenu: true
  },
  {
    id: '334211a3-4385-11ef-99b5-0aa6baaecec9',
    path: '/retail-media/placements/create',
    onlyPublisher: true,
    name: i.t('rm:placements.create.pageTitle'),
    pageTitle: i.t('rm:placements.create.pageTitle'),
    component: placementsPages.create,
    hideMenu: true
  }
]

/**
 * 8. Tamanhos de mídias
 */
const adSizes: ChildMenuItem[] = [
  {
    id: 'ee4d83b6-dd83-4169-8109-e1519e76195d', // rota-sem-id
    path: '/retail-media/ad-sizes',
    onlyPublisher: true,
    name: `${i.t('rm:adsize.page.title')}`,
    pageTitle: i.t('rm:adsize.page.title'),
    component: AdSizes
  }
]

/**
 *  9. Relatórios
 */
const reports: ChildMenuItem[] = [
  {
    id: null,
    name: i.t('rm:Reports'),
    path: '#',
    hasChildren: true
  },
  {
    id: null, // rota-sem-id
    path: '/retail-media/report/ads',
    name: `${i.t('rm:adsReports')}`,
    pageTitle: i.t('rm:adsReports'),
    contentFullWidth: true,
    component: RetailMediaReport
  },
  {
    id: null, // rota-sem-id
    path: '/retail-media/report/overview',
    name: `${i.t('rm:reports.management')}`,
    pageTitle: i.t('rm:reports.management'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true
  },
  {
    id: null, // rota-sem-id
    path: '/retail-media/report/hour_overview',
    name: `${i.t('rm:reports.hourlyManagement')}`,
    pageTitle: i.t('rm:reports.hourlyManagement'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true,
    hideMenu: true
  },
  {
    id: null, // rota-sem-id
    path: '/retail-media/report/advertisers',
    name: `${i.t('rm:reports.advertisers')}`,
    pageTitle: i.t('rm:reports.advertisers'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true,
    hideMenu: true
  },
  {
    id: null, // rota-sem-id
    path: '/retail-media/report/advertisers_state',
    name: `${i.t('rm:reports.advertisersState')}`,
    pageTitle: i.t('rm:reports.advertisersState'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true,
    hideMenu: true
  },

  {
    id: null, // rota-sem-id
    path: '/retail-media/report/opportunity_cost',
    name: `${i.t('rm:reports.opportunityCost')}`,
    pageTitle: i.t('rm:reports.opportunityCost'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true,
    hideMenu: true
  },

  {
    id: null, // rota-sem-id
    path: '/retail-media/report/daily_consolidation',
    name: `${i.t('rm:reports.dailyConsolidation')}`,
    pageTitle: i.t('rm:reports.dailyConsolidation'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true,
    hideMenu: true
  },

  {
    id: null, // rota-sem-id
    path: '/retail-media/report/network_subpublisher_performance',
    name: `${i.t('rm:reports.networkSubpublisherPerformance')}`,
    pageTitle: i.t('rm:reports.networkSubpublisherPerformance'),
    contentFullWidth: true,
    component: RetailMediaReport,
    onlyPublisher: true,
    hideMenu: true
  }
]

/**
 *  10. Configurações
 */
const configs: ChildMenuItem[] = [
  {
    id: null,
    name: i.t('rm:Configurations'),
    path: '#',
    onlyPublisher: true,
    hasChildren: true
  },
  {
    id: null,
    name: `${i.t('rm:config.advertisers.menu')}`,
    pageTitle: i.t('rm:config.advertisers.pageTitle'),
    path: '/retail-media/config/advertisers',
    component: AdvertisersConfig,
    onlyPublisher: true
  },
  {
    id: null,
    name: `${i.t('rm:config.advertisers.create.menu')}`,
    pageTitle: i.t('rm:config.advertisers.create.pageTitle'),
    path: '/retail-media/config/advertisers/create',
    component: CreateAdvertiserConfig,
    onlyPublisher: true,
    permissionType: 'admin',
    hideMenu: true
  },
  {
    id: null,
    name: `${i.t('rm:config.adTypes.menu')}`,
    pageTitle: i.t('rm:config.adTypes.pageTitle'),
    path: '/retail-media/config/ad-types',
    component: RetaipMediaAdTypesPage,
    onlyPublisher: true
  },
  {
    id: null,
    name: `${i.t('rm:config.termsOfService.menu')}`,
    pageTitle: i.t('rm:config.termsOfService.pageTitle'),
    path: '/retail-media/config/terms-of-service',
    component: RetailMediaTermsOfServicePage,
    onlyPublisher: true
  },
  {
    id: null,
    name: `${i.t('rm:config.catalog.menu')}`,
    pageTitle: i.t('rm:config.catalog.pageTitle'),
    path: '/retail-media/config/catalog',
    component: RetailMediaCatalog,
    onlyPublisher: true,
    contentFullWidth: true
  },
  {
    id: null,
    name: `${i.t('rm:config.destinationRetail.menu')}`,
    pageTitle: i.t('rm:config.destinationRetail.pageTitle'),
    path: '/retail-media/config/destination-retail',
    component: DestinationRetailConfigPage,
    onlyPublisher: true
  }
  // {
  //   id: null,
  //   name: `${i.t('rm:config.campaignPermissions.menu')}`,
  //   pageTitle: i.t('rm:config.campaignPermissions.pageTitle'),
  //   path: '/retail-media/config/campaign-permissions',
  //   component: RetailMediaCampaignPermissionsPage,
  //   onlyPublisher: true
  // }
]

/**
 *  11. Audiências
 */
const audiences: ChildMenuItem[] = [
  // Audiences
  {
    path: '/retail-media/audiences',
    component: audiencesRoutes.list,
    id: '94834e03-9a91-42b4-8875-1a048ae23b96',
    name: i.t('rm:Audiences'),
    pageTitle: i.t('rm:Audiences')
  },
  {
    path: '/retail-media/audiences/publisher',
    component: audiencesRoutes.listByPublisher,
    id: null,
    name: i.t('rm:Audiences'),
    pageTitle: i.t('rm:Audiences'),
    hideMenu: true
  },
  {
    path: '/retail-media/audiences/advertiser',
    component: audiencesRoutes.listByAdvertiser,
    id: null,
    name: i.t('rm:Audiences'),
    pageTitle: i.t('rm:Audiences'),
    hideMenu: true
  },
  {
    // A pagina tem 2 variações (mode):
    // mode = undefined  => audiências criadas pelo anunciante
    // mode = available => audiências do publisher disponíveis para o anunciante
    path: '/retail-media/audiences/advertiser/:id/:mode?',
    component: audiencesRoutes.listByAdvertiser,
    id: null,
    name: i.t('rm:Audiences'),
    pageTitle: i.t('rm:Audiences'),
    hideMenu: true
  },
  // Audiences create
  {
    path: '/retail-media/audiences/create',
    component: AudienceCreatePage,
    id: null,
    name: capitalizeI18n('rm:audience_other'),
    pageTitle: i.t('rm:config.advertisers.pageTitle'),
    hideMenu: true
  },
  // Audiences view
  {
    path: '/retail-media/audiences/view/:audienceId',
    component: AudienceViewPage,
    id: null,
    name: capitalizeI18n('rm:audience_one'),
    pageTitle: capitalizeI18n('rm:audience_one'),
    hideMenu: true
  },
  // Audiences enriched
  {
    path: '/retail-media/audiences/enriched-audiences',
    component: AudiencesEnriched,
    name: i.t('rm:audience.audienceEnriched.pageTitle'),
    pageTitle: i.t('rm:audience.audienceEnriched.pageTitle'),
    hideMenu: true,
    id: null
  },
  {
    path: '/retail-media/audiences/enriched-audiences/:id/edit',
    component: AudiencesEnriched,
    name: i.t('rm:audience.audienceEnriched.pageTitle'),
    pageTitle: i.t('rm:audience.audienceEnriched.pageTitle'),
    hideMenu: true,
    id: null
  },
  {
    path: '/retail-media/audiences/advertisers',
    component: audiencesRoutes.advertisers,
    name: i.t('rm:audience.advertisers.pageTitle'),
    pageTitle: i.t('rm:audience.advertisers.pageTitle'),
    hideMenu: true,
    id: null
  },
  {
    path: '/retail-media/audiences/review',
    component: ReviewAudience,
    name: i.t('rm:audience.review.pageTitle'),
    pageTitle: i.t('rm:audience.review.pageTitle'),
    hideMenu: true,
    id: null,
    onlyPublisher: true
  }
]

/**
 *  12. Ferramentas
 */
const tools: ChildMenuItem[] = [
  {
    id: null,
    name: i.t('rm:Tools'),
    path: '#',
    onlyPublisher: true,
    hasChildren: true
  },
  {
    path: '/retail-media/tools/requests',
    component: RequestTesterPage,
    id: null,
    name: `${i.t('rm:Tools.AdRequest')}`,
    pageTitle: i.t('rm:Tools.AdRequest.pageTitle'),
    onlyPublisher: true
  }
]

const creativeStudio: ChildMenuItem[] = [
  {
    path: '/retail-media/tools/creative-studio',
    component: CreativeStudioPage,
    id: '07939fca-59e8-4139-9e05-150e37f6ff67',
    name: i.t('rm:Tools.CreativeStudio'),
    pageTitle: i.t('rm:Tools.CreativeStudio.pageTitle'),
    contentFullWidth: true,
    contentFullScreen: true
  }
]

const campaignManager: ChildMenuItem[] = [
  {
    id: null,
    path: '/retail-media/tools/campaign-manager',
    name: i.t('rm:Tools.CampaignManager'),
    component: () => null,
    onlySuperAdmin: true,
    onlyAdvertiser: true
  }
]

/**
 *  13. External Campaign Metrics
 */

const externalCampaignMetrics: ChildMenuItem[] = [
  {
    id: 'e6b26e27-2c01-408f-8879-732d8c44c850',
    name: i.t('rm:ExternalCampaignMetrics'),
    path: '#',
    onlyPublisher: true,
    hasChildren: true
  },
  {
    path: '/retail-media/external-campaign-metrics',
    component: ExternalCampaignMetricsPage,
    id: '7f57d2aa-7f24-4018-8ea7-517a59a850a2',
    name: `${i.t('rm:ExternalCampaignMetrics.pageTitle')}`,
    pageTitle: i.t('rm:ExternalCampaignMetrics.pageTitle'),
    onlyPublisher: true
  }
]

/**
 * 9999. Extras
 * Demais (MVP e uso interno)
 */
const extras: ChildMenuItem[] = [
  // Newtail Media TV
  {
    id: null,
    path: '/activate',
    name: rootTexts.dashboard,
    contentFullWidth: true,
    component: TvRoutes.activate,
    hideMenu: true,
    onlyPublisher: true
  },
  {
    id: null,
    path: '/activate/:device_token',
    name: rootTexts.dashboard,
    contentFullWidth: true,
    component: TvRoutes.activate,
    hideMenu: true,
    onlyPublisher: true
  },
  {
    id: null,
    path: '/retail-media/tv/devices',
    name: 'TVs Ativadas',
    contentFullWidth: true,
    component: TvRoutes.devices,
    hideMenu: true,
    onlyPublisher: true
  },
  // Placements

  /**
   * Check
   */
  {
    sidebarStartsClosed: true,
    id: null, // rota-sem-id
    path: '/retail-media/check',
    name: 'Monitoramento de métricas',
    contentFullWidth: true,
    component: RetailMediaCheck,
    hideMenu: true,
    onlyPublisher: true
  }
]

export const retailMedialRoutes: RootMenuItem<IconType> = {
  id: 'b1ced6c3-13ba-444a-bbd1-13a83d637ee2',
  path: '/retail-media',
  name: rootTexts.label,
  icon: icon,
  children: [].concat(
    // dashboard,
    links,
    campaigns,
    ads,
    subPublishers,
    audiences,
    wallets,
    creativeStudio,
    campaignManager,
    reports,
    configs,
    placements,
    adSizes,
    tools,
    externalCampaignMetrics,
    extras
  )
}

/**
 * Catálogo de produtos do anunciante — grupo próprio no menu, sob o mesmo
 * módulo de permissão do retail media; dentro dele, `allow_ntb_metrics`
 * ainda filtra na sidebar e barra na página.
 */
export const advertiserCatalogRoutes: RootMenuItem<IconType> = {
  id: 'b1ced6c3-13ba-444a-bbd1-13a83d637ee2',
  path: '/advertiser-catalog',
  onlyNtbEnabled: true,
  name: `${i.t('rm:advertiserCatalog.menu')}`,
  pageTitle: i.t('rm:advertiserCatalog.menu'),
  icon: catalogIcon,
  children: [
    {
      id: null,
      path: '/advertiser-catalog/products',
      name: `${i.t('rm:advertiserProducts.menu')}`,
      pageTitle: i.t('rm:advertiserProducts.pageTitle'),
      component: AdvertiserProductsPage,
      onlyAdvertiser: true,
      contentFullScreen: true
    },
    {
      id: null,
      path: '/advertiser-catalog/brands',
      name: `${i.t('rm:advertiserBrands.menu')}`,
      pageTitle: i.t('rm:advertiserBrands.pageTitle'),
      component: AdvertiserBrandsPage,
      onlyAdvertiser: true,
      contentFullScreen: true
    }
  ]
}
